import React, { useContext, Fragment } from 'react';
import { List, SpinLoading, ErrorBlock, Ellipsis, Tag } from 'antd-mobile';
import moment from 'moment';
import { useHistory } from 'react-router-dom';
import { get } from 'lodash';
import styled from 'styled-components';
import { matchesPermission } from '../utils/permission-helpers';
import { UTILIZATION_TYPE_FLIGHT, UTILIZATION_TYPE_MAINTENANCE, UTILIZATION_TYPE_TITLES } from '../utils/constants';
import { getWorkOrderStatusData } from '../utils/helpers';
import UserSelfContext from '../utils/self-context';

const Records = styled(List)`
	width: 100%;
	padding: 12px 0px;
	.adm-list-item-content-extra {
		display: flex;
	}
`;

const SpinWrapper = styled.div`
	display: flex;
	width: 100%;
	height: 100%;
	align-items: center;
	justify-content: center;
`;

function LogbookList(props) {
	const {
		records,
		loading
	} = props;
	const history = useHistory();
	const { userSelf } = useContext(UserSelfContext);

	function getLogbookList() {
		if (!records.length) {
			return <ErrorBlock
				style={{ paddingTop: 12 }}
				description={null}
				title={'No records added'}
				status='empty'
			/>;
		}

		return <Records>
			{records.map((record) => {
				return <List.Item
					key={record.id}
					title={<Fragment>
						{<Tag fill='outline' color={UTILIZATION_TYPE_TITLES[record.type].color}>{UTILIZATION_TYPE_TITLES[record.type].text}</Tag>}
						{record.flight && <span> &middot; </span>}
						{record.flight && <span>{record.flight}</span>}
						{record.tlog && <span> &middot; </span>}
						{record.tlog && <span>{record.tlog}</span>}
					</Fragment>}
					description={
						<Fragment>
							{record.remarks && <Ellipsis direction='end' rows={2} content={record.remarks ? `Remarks: ${record.remarks}` : ''} />}
							{record.description && <Ellipsis direction='end' rows={2} content={record.description ? `Maintenance actions: ${record.description}` : ''} />}
						</Fragment>
					}
					extra={<Tag color={getWorkOrderStatusData(record.status).color}>{getWorkOrderStatusData(record.status).text}</Tag>}
					onClick={() => history.push(`/aircraft/${record.aircraft_id}/tech-log/${record.id}`)}
					clickable={matchesPermission(userSelf, 'edit_utilization')}
				>
					<div style={{ marginTop: 6 }}>
						{record.type === UTILIZATION_TYPE_FLIGHT && <div><span>{record.from || '-'}</span> - <span>{record.to || '-'}</span></div>}
						{record.type === UTILIZATION_TYPE_MAINTENANCE && <div><span>{record.from}</span></div>}
						<div>
							<small>
								<span>{`${record.date_toff ? moment(record.date_toff).format(get(userSelf.settings, 'date_format')) : ''}`} </span>
								<span>{`${(record.time_toff ? moment(record.time_toff, 'HH:mm:ss').format('HH:mm') : '')}`}</span> - <span>{`${(record.time_lnd ? moment(record.time_lnd, 'HH:mm:ss').format('HH:mm') : '')}`}</span>
							</small>
						</div>
					</div>
				</List.Item>;
			})}
		</Records>;
	}

	return (
		loading ? <SpinWrapper><SpinLoading style={{ '--size': '48px' }} /></SpinWrapper> : <Fragment>
			{getLogbookList()}
		</Fragment>
	);
}

export default LogbookList;
